"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _social = require("../components/social");

var _sections = require("../components/contentful-views/sections");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Maps to the Social Card content model on Contentful
 * https://app.contentful.com/spaces/ljtyf78xujn2/content_types/socialCard/fields
 * @param {Object} props
 * @param {Object} props.fields
 */
var SocialCardWidget = function SocialCardWidget(_ref) {
  var _fields$authorPhoto, _fields$authorPhoto$f, _fields$authorPhoto$f2, _fields$photo, _fields$photo$fields, _fields$photo$fields$;

  var _ref$model = _ref.model;
  _ref$model = _ref$model === void 0 ? {} : _ref$model;
  var _ref$model$fields = _ref$model.fields,
      fields = _ref$model$fields === void 0 ? {} : _ref$model$fields;
  var authorPhotoUrl = fields === null || fields === void 0 ? void 0 : (_fields$authorPhoto = fields.authorPhoto) === null || _fields$authorPhoto === void 0 ? void 0 : (_fields$authorPhoto$f = _fields$authorPhoto.fields) === null || _fields$authorPhoto$f === void 0 ? void 0 : (_fields$authorPhoto$f2 = _fields$authorPhoto$f.file) === null || _fields$authorPhoto$f2 === void 0 ? void 0 : _fields$authorPhoto$f2.url;
  var photoUrl = fields === null || fields === void 0 ? void 0 : (_fields$photo = fields.photo) === null || _fields$photo === void 0 ? void 0 : (_fields$photo$fields = _fields$photo.fields) === null || _fields$photo$fields === void 0 ? void 0 : (_fields$photo$fields$ = _fields$photo$fields.file) === null || _fields$photo$fields$ === void 0 ? void 0 : _fields$photo$fields$.url;
  var authorHandle = fields.authorHandle,
      authorName = fields.authorName,
      url = fields.url;
  return /*#__PURE__*/_react["default"].createElement(_social.SocialCard, {
    authorHandle: authorHandle,
    authorName: authorName,
    url: url,
    photoUrl: photoUrl,
    authorPhotoUrl: authorPhotoUrl
  });
};

SocialCardWidget.propTypes = {
  model: _propTypes["default"].shape({
    fields: {}
  })
};
SocialCardWidget.defaultProps = {
  model: {
    fields: {}
  }
};
(0, _sections.registerWidget)("socialCard", SocialCardWidget);
var _default = SocialCardWidget;
exports["default"] = _default;